import React, { Fragment, useState, useEffect } from 'react';
import { injectIntl } from 'react-intl';
import { ACL } from '../../../../../config/constants';
import { updateCoupon as updateCouponApi } from "../../../../../api/coupons/coupons";

function ActivateDeactivateCouponComponent(props) {
  const { coupon, index } = props;
  const [ intervalActive, setIntervalActive ] = useState(!!(coupon && coupon.status));

  const hasCampaignsEditRights = () => {
    return ACL.CLIENT.CAMPAIGNS.LIST.hasAccess() && ACL.CLIENT.CAMPAIGNS.SEARCH.hasAccess() && ACL.CLIENT.CAMPAIGNS.EDIT.hasAccess()
  }

  const hasCouponEditAccess = () => {
    return hasCampaignsEditRights() && ACL.CLIENT.COUPONS.LIST.hasAccess() && ACL.CLIENT.COUPONS.SEARCH.hasAccess() && ACL.CLIENT.COUPONS.CREATE.hasAccess() && ACL.CLIENT.COUPONS.EDIT.hasAccess();
  };

  useEffect(() => {
    setIntervalActive(coupon.status);
  }, [coupon.status]);

  if (! hasCouponEditAccess()) {
    return null;
  }

  const updateCoupon = () => {
    updateCouponApi({
      id: coupon && coupon.id ? coupon.id : '',
      data: {
        status: !intervalActive ? 1 : 0,
      },
    })
      .then(response => {
      if (response && response.data) {
        setIntervalActive(response.data.status);
      }
    });
  }

  return (
    <Fragment>
      <label className="custom-toggle ml-3 mr-3 px-4">
        <input
          id={ `enable-disable-coupon-${coupon && coupon.id ? coupon.id : ''}` }
          type="checkbox"
          name="enable_disable_coupon"
          checked={ intervalActive }
          onChange={ updateCoupon }
          key={ index }
        />
        <span className="custom-toggle-slider rounded-circle" />
      </label>
    </Fragment>
  )
}

const ActivateDeactivateCoupon = injectIntl(ActivateDeactivateCouponComponent);
export { ActivateDeactivateCoupon, ActivateDeactivateCouponComponent }
